export const COMPLETE_TODO="COMPLETE_TODO"
export const ADD_TODO="ADD_TODO"
export const REMOVE_TODO="REMOVE_TODO"
export const UPDATE_TODO="UPDATE_TODO"